import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'

const basePath = '/v-admin/client-admin/service-account-management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_COMPANY_APPROVAL'],
    menu: {
      labelI18nKey: 'admin.customer.serviceAccountManagement.menu'
    }
  },
  children: [
    {
      path: `${basePath}/`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.serviceAccountManagement.title'
      }
    }
  ]
}
